import { useEffect, useRef } from 'react'

const DEFAULT_USER_INTERACTION_EVENTS = [
  'mousedown',
  'keydown',
  'scroll',
  'touchstart',
]

/**
 * Custom hook that waits for the first user interaction from a set of events,
 * then calls the provided callback and removes all listeners.
 * @param onFirstInteraction Callback to call after first interaction
 */
export const useUserInteractionGate = (
  onFirstInteraction: () => void,
): void => {
  const triggeredRef = useRef(false)

  useEffect(() => {
    if (triggeredRef.current) {
      return
    }
    const handler = (): void => {
      if (!triggeredRef.current) {
        triggeredRef.current = true
        for (const event of DEFAULT_USER_INTERACTION_EVENTS) {
          window.removeEventListener(event, handler)
        }
        onFirstInteraction()
      }
    }
    for (const event of DEFAULT_USER_INTERACTION_EVENTS) {
      window.addEventListener(event, handler, { passive: true })
    }

    return (): void => {
      for (const event of DEFAULT_USER_INTERACTION_EVENTS) {
        window.removeEventListener(event, handler)
      }
    }
  }, [onFirstInteraction])
}
